import React, { useState, useEffect } from "react";
import { DatePicker, Button, Tooltip, notification } from "antd";
import Table from "./table/AuditReportTable";
import { VscArrowRight } from "react-icons/vsc";
import { HiOutlineInboxArrowDown } from "react-icons/hi2";
import auditFilter from "./AuditFilter";
import Utils from "../../../utility/Utils";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import { useReportsStore } from "../ReportsStore";
import { useSearchParams } from "react-router-dom";
import dbstorage from "../../../lib/DBStorage";

import notificationFilter from "../../../components/NotificationFilter";
import { useComponentStore } from "../../../components/ComponentsStore";
const { RangePicker } = DatePicker;

const AuditReport = () => {
  const today = dayjs();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const {
    auditReportRangeFilter,
    setAuditReportRangeFilter,
    auditFirstRender,
    setAuditFirstRender,
  } = useReportsStore();
  const { setNotificationCount } = useComponentStore();
  const fetchData = async () => {
    try {
      setLoading(true);
      if (auditFirstRender) {
        let auditReportStartDate = searchParams.get("auditReportStartDate");

        let auditReportEndDate = searchParams.get("auditReportEndDate");

        if (auditReportStartDate && auditReportStartDate.length > 0) {
          setAuditReportRangeFilter([
            dayjs(auditReportStartDate),

            dayjs(auditReportEndDate),
          ]);
        }
        setAuditFirstRender(false);
      }
      const auditData = await auditFilter.getAuditReport(
        auditReportRangeFilter[0],
        auditReportRangeFilter[1]
      );

      setTableData(auditData);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!auditFirstRender) {
      updateQueryParams();
    }
  }, [auditReportRangeFilter]);
  useEffect(() => {
    fetchData();
  }, [auditReportRangeFilter]);
  const updateQueryParams = () => {
    setSearchParams({
      auditReportStartDate:
        auditReportRangeFilter[0] !== null
          ? dayjs(auditReportRangeFilter[0].$d).format("DD-MM-YYYY")
          : "",
      auditReportEndDate:
        auditReportRangeFilter[1] !== null
          ? dayjs(auditReportRangeFilter[1].$d).format("DD-MM-YYYY")
          : "",
    });
  };
  const handleDateRangeChange = (dates) => {
    if (dates) {
      setAuditReportRangeFilter(dates);
    }
  };
  const [api, contextHolder] = notification.useNotification();
  const noDataNotification = () => {
    api.info({ title: "No Data Available !",
      placement: "bottomRight",
      style: { backgroundColor: "#ceddf5" },
      duration: 2,
    });
  };
  const handleDownloadClick = async () => {
    if (!tableData.length) {
      noDataNotification();
      return;
    } else {
      await download();
    }
  };
  const download = async () => {
    try {
      let userid;
      await dbstorage.get("user").then((user) => {
        userid = user._id;
      });

      await notificationFilter.createCsv("audit_report", userid,"","","","");
      const count = await notificationFilter.getCount(userid);

      setNotificationCount(count.count);

      // return transformedCsvData;
    } catch (error) {
      console.error(error);
    }
  };
  const disableFutureDate = (current) => {
    return current && current.isAfter(today);
  };

  const headers = [
    { label: "User Name", key: "audit_user_name" },
    { label: "User IP", key: "audit_user_ip" },
    { label: "Time", key: "audit_time" },
    { label: "Browser", key: "audit_browser" },
  ];

  return (
    <>
      <div className="card-background">
        <div className="d-flex justify-content-between mb-3 align-items-center">
          <div className="search-filter">
            <RangePicker
              separator={<VscArrowRight />}
              suffixIcon={""}
              allowClear={false}
              value={auditReportRangeFilter}
              onChange={handleDateRangeChange}
              disabledDate={disableFutureDate}
              format="DD-MM-YYYY"
            ></RangePicker>
          </div>
          <div className="card-heading">
            Audit Report ({auditReportRangeFilter[0].$d.getDate()}-
            {auditReportRangeFilter[0].$d.getMonth() + 1}-
            {auditReportRangeFilter[0].$d.getFullYear()} to{" "}
            {auditReportRangeFilter[1].$d.getDate()}-
            {auditReportRangeFilter[1].$d.getMonth() + 1}-
            {auditReportRangeFilter[1].$d.getFullYear()})
          </div>
          <div>
            <Button
              className="border-0 shadow-none me-4"
              icon={
                <Tooltip title="Download">
                  <span>
                    <HiOutlineInboxArrowDown className="text-color-grey fs-4" />
                  </span>
                </Tooltip>
              }
              type="text"
              onClick={handleDownloadClick}
            />
            {/* <Button
              className="border-0 shadow-none text-color-grey "
              icon={
                <Tooltip title="Download CSV">
                  <CSVLink
                    data={[
                      [
                        `Audit Report (${auditReportRangeFilter[0].$d.getDate()}-${
                          auditReportRangeFilter[0].$d.getMonth() + 1
                        }-${auditReportRangeFilter[0].$d.getFullYear()} to ${auditReportRangeFilter[1].$d.getDate()}-${
                          auditReportRangeFilter[1].$d.getMonth() + 1
                        }-${auditReportRangeFilter[1].$d.getFullYear()})`,
                      ],

                      headers.map((header) => header.label),
                      ...tableData.map((row) => [
                        row.audit_user_name,
                        row.audit_user_ip,
                        Utils.istTime(row.audit_time),
                        row.audit_browser,
                      ]),
                    ]}
                    filename={"AuditReport.csv"}
                  >
                    <HiOutlineInboxArrowDown className="text-color-grey fs-4" />
                  </CSVLink>
                </Tooltip>
              }
              type="text"
              size="large"
            /> */}
          </div>
        </div>
        <Table loading={loading} tableData={tableData} />
      </div>
    </>
  );
};

export default AuditReport;
